import { render, staticRenderFns } from "./EquipType.vue?vue&type=template&id=1a97b300&scoped=true"
import script from "./EquipType.vue?vue&type=script&lang=js"
export * from "./EquipType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97b300",
  null
  
)

export default component.exports